export default {
  cfgChanged: '配置变更成功',
  dpiChanged: 'DPI档位切换成功',
  rtChanged: 'RT档位切换成功',
}
